import { TApiTeamTarget } from "@timenotes/shared/src/services/api-client/types"
import TeamFilter from "../filters/team-filter"

interface Props {
  value: TApiTeamTarget[]
  onChange(value: TApiTeamTarget[]): void
  placeholder?: string
}

export function TeamTargetsFilter(props: Props) {
  const {
    value: targets,
    onChange,
    placeholder,
  } = props

  const userAccountIds = targets.filter((t) => (t.type == 'user')).map((t) => t.id) || []
  const groupIds = targets.filter((t) => (t.type == 'group')).map((t) => t.id) || []

  const teamFilterValues = {
    memberHashIds: userAccountIds,
    groupHashIds: groupIds,
  }

  return (
    <TeamFilter 
      placeholder={placeholder}
      assignee // makes it use id's
      values={teamFilterValues}

      onChange={(values) => {
        const newTargets = [
          ...values.memberHashIds.map((mId) => ({ id: mId, type: 'user'} as TApiTeamTarget)),
          ...values.groupHashIds.map((mId) => ({ id: mId, type: 'group'} as TApiTeamTarget)),
        ]

        onChange(newTargets)
      }}
    />
  )
}